module.exports = __webpack_public_path__ + "static/media/geewin-exim.7237fcfc.png";